<template>
  <div class="form-elements">
    <!-- <div class="va-row">
      <div class="flex md12 xs12"> -->
    <div class="kyc-information-status">
      <fieldset class="info-group senior-top">
        <legend class="senior-title">{{ $t("kyc.kycInformation") }}<!-- （<span>{{kycInformationStatus}}</span>） -->
        </legend>
        <div class="senior-buttons"
             v-if="kycStatus==='saved'">
          <button class="btn btn-primary btn-sm comfirm-ok"
                  @click="savedAll">{{ $t("kyc.save") }}</button>
          <button class="btn btn-danger btn-sm comfirm-ok"
                  @click="submitAll">{{ $t("basic.button.submit") }}</button>
        </div>
      </fieldset>
    </div>
    <vuestic-widget>
      <!-- First Edit -->
      <SimpleHorizontalIndicator ref="simpleHorizontalIndicator" v-if="kycStatus==='firstEdit'"
                                 :steps=steps
                                 wizardType="simple"
                                 wizardLayout="horizontal"
                                 :currentComponent="currentComponent"
                                 @wizardComplete="wizardComplete"
                                 @changeCurrentStep="changeCurrentStep">
        <div slot="first"
             class="form-wizard-tab-content">
          <basic-infomation ref="basicInfo"
                            :kycStatus="kycStatus"
                            v-if="currentComponent === 'basicInformation'"
                            @updateKycInformation="updateKycInformation(arguments)"></basic-infomation>
          <license-information ref="licenseInfo"
                               :kycStatus="kycStatus"
                               v-if="currentComponent === 'licenseInformation'"
                                @updateKycInformation="updateKycInformation(arguments)"></license-information>
          <upload-attachment  ref="uploadAttachment"
                              v-if="currentComponent === 'uploadAttachment'"
                              :kycStatus="kycStatus"
                              @updateKycInformation="updateKycInformation(arguments)"></upload-attachment>
        </div>
        <div slot="second"
             class="form-wizard-tab-content">
          <business-information ref="businessInformation"
                                :kycStatus="kycStatus"
                                v-if="currentComponent === 'businessInformation'"
                                @updateKycInformation="updateKycInformation(arguments)"></business-information>
          <bank-information ref="bankInfo"
                            :kycStatus="kycStatus"
                            v-if="currentComponent === 'bankInformation'"
                            @updateKycInformation="updateKycInformation(arguments)"></bank-information>
          <senior-management ref="seniorManage"
                             :kycStatus="kycStatus"
                             v-if="currentComponent === 'seniorManagement'"
                             @updateKycInformation="updateKycInformation(arguments)"></senior-management>
          <ultimate-beneficiary ref="ultimateBenefit"
                                :kycStatus="kycStatus"
                                v-if="currentComponent === 'ultimateBeneficiary'"
                                @updateKycInformation="updateKycInformation(arguments)"></ultimate-beneficiary>
        </div>
        <div slot="three"
             class="form-wizard-tab-content">
          <compliance-questionnaire ref="compliance"
                                    :kycStatus="kycStatus"
                                    v-if="currentComponent === 'complianceQuestionnaire'"></compliance-questionnaire>
        </div>
      </SimpleHorizontalIndicator>
      <!-- saved -->
      <div v-if="kycStatus==='saved' || kycStatus==='submitted'">
        <basic-infomation   ref="basicInfo"
                            :kycStatus="kycStatus"
                            @updateKycInformation="updateKycInformation(arguments)"
                            @changeRegionHK="changeRegionHK"
                            :merchantData="merchantData"></basic-infomation>
        <license-information ref="licenseInfo"
                               :kycStatus="kycStatus"
                                @updateKycInformation="updateKycInformation(arguments)"
                                :merchantData="merchantData"></license-information>
        <upload-attachment  ref="uploadAttachment"
                              :kycStatus="kycStatus"
                              @updateKycInformation="updateKycInformation(arguments)"
                              :merchantData="merchantData"></upload-attachment>
        <div class="kyc-saved-m"></div>
        <business-information ref="businessInformation"
                                :kycStatus="kycStatus"
                                @updateKycInformation="updateKycInformation(arguments)"
                                :merchantData="merchantData"></business-information>
        <div class="kyc-saved-m"></div>
        <bank-information ref="bankInfo"
                            :kycStatus="kycStatus"
                            @updateKycInformation="updateKycInformation(arguments)"
                            :merchantData="merchantData"></bank-information>
        <div class="kyc-saved-m"></div>
        <senior-management ref="seniorManage"
                             :kycStatus="kycStatus"
                             @updateKycInformation="updateKycInformation(arguments)"
                             @changeUltimateBeneficiary="changeUltimateBeneficiary"
                             :merchantData="merchantData"></senior-management>
        <ultimate-beneficiary ref="ultimateBenefit"
                                :kycStatus="kycStatus"
                                @updateKycInformation="updateKycInformation(arguments)"
                                @changeSeniorManagement="changeSeniorManagement"
                                :merchantData="merchantData"></ultimate-beneficiary>
        <div class="kyc-saved-m"></div>
        <compliance-questionnaire ref="compliance"
                                    :kycStatus="kycStatus"
                                    :merchantData="merchantData"></compliance-questionnaire>
      </div>
      <!-- submitted -->
      <!-- <div v-if="kycStatus==='submitted'"></div> -->
    </vuestic-widget>
  </div>
</template>

<script>
import {
  request,
  // checkEmail,
  // checkUrl,
  // checkMobileOversea,
  // exeTextLine,
} from '@/utils/utils.js'
import SimpleHorizontalIndicator from '../../vuestic-theme/vuestic-components/vuestic-wizard-kyc/VuesticWizard'
import BasicInfomation from './components/BasicInfomation'
import LicenseInformation from './components/LicenseInformation'
import UploadAttachment from './components/UploadAttachment'
import BusinessInformation from './components/BusinessInformation'
import BankInformation from './components/BankInformation'
import SeniorManagement from './components/SeniorManagement'
import UltimateBeneficiary from './components/UltimateBeneficiary'
import ComplianceQuestionnaire from './components/ComplianceQuestionnaire'

import mixin from './mixins/mixin'

export default {
  mixins: [mixin],
  name: 'MerchantKYC',
  components: {
    SimpleHorizontalIndicator,
    BasicInfomation,
    LicenseInformation,
    UploadAttachment,
    BusinessInformation,
    BankInformation,
    SeniorManagement,
    UltimateBeneficiary,
    ComplianceQuestionnaire,
  },
  data () {
    let that = this
    return {
      merchantNo: '',
      kycStatus: 'firstEdit', // firstEdit、saved、submitted
      currentComponent: 'basicInformation', // basicInformation/uploadAttachment/businessInformation/complianceQuestionnaire
      steps: [
        {
          label: '① Start Your KYC',
          slot: 'first',
          isValid: function () {
            // console.log("vvvv");
            return that.isValidAll()
          },
          onNext: function () {
            // console.log("next1");
            that.next()
          },
          onBack: function () {
            // console.log("back1");
            that.back()
          },
        },
        {
          label: '② More Information',
          slot: 'second',
          isValid: function () {
            return that.isValidAll()
          },
          onNext: function () {
            // console.log("next2");
            that.next()
          },
          onBack: function () {
            // console.log("back2");
            that.back()
          },
        },
        {
          label: '③ Compliance Questionnaire',
          slot: 'three',
          isValid: function () {
            return that.isValidAll()
          },
          onNext: function () {
            // console.log("next3");
            that.next()
          },
          onBack: function () {
            // console.log("back3");
            that.back()
          },
        },
      ],
      merchantData: {}
    }
  },
  computed: {
    kycInformationStatus: function () {
      switch (this.kycStatus) {
        case 'firstEdit':
          return 'edit'
        case 'saved':
          return 'saved'
        case 'submitted':
          return 'submitted'
        default:
          return ''
      }
    },
  },
  async mounted () {
    let merchantNo = localStorage.getItem('merchantNo')
    if (merchantNo) {
      this.merchantNo = merchantNo
      this.kycInit()
    } else {
      // 如果商户merchantNo不存在？
    }
  },
  watch: {
    currentComponent (val) {
      // console.log('值发生变化', val)
    },
  },
  methods: {
    kycInit () {
      // 获取商户KYC信息
      let that = this
      that.getMerchantKYCInfo(9, (data) => {
        if (data.is_submited) {
          that.kycStatus = 'submitted'
          that.merchantData = data // TODO
        } else if (data.is_saved) {
          that.kycStatus = 'saved'
          that.merchantData = data // TODO
        } else {
          that.kycStatus = 'firstEdit'
        }
      })
    },
    submitKycInformation (params, callback) {
      this.loadingFullScreen('Subbmiting', 'Subbmiting', 'fa fa-hourglass-half')
      let token = localStorage.getItem('Authorization')
      let newParams = Object.assign(params, { 'merchant_no': this.merchantNo })
      request({
        method: 'post',
        url: `api/dashboard/merchant/kyc/submit?access_token=${token}`,
        data: JSON.stringify(newParams),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          this.Subbmiting.close()
          // eslint-disable-next-line standard/no-callback-literal
          let data = res.data
          if (data.code === '10000') {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            callback && callback(data.data)
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            })
          }
        })
        .catch(() => {
          this.Subbmiting.close()
          this.$message({
            type: 'warn',
            message: 'fail'
          })
        })
    },
    updateKycInformation (info) {
      this.loadingFullScreen('Saving', 'Saving', 'fa fa-hourglass-half')
      let token = localStorage.getItem('Authorization')
      let params = Object.assign(info[0], { 'merchant_no': this.merchantNo })
      let callback = info[1]
      request({
        method: 'post',
        url: `api/dashboard/merchant/kyc/updateMerchantKYCInfo?access_token=${token}`,
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          this.Saving.close()
          // eslint-disable-next-line standard/no-callback-literal
          let data = res.data
          if (data.code === '10000') {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            callback && callback(data.data)
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            })
          }
        })
        .catch(() => {
          this.Saving.close()
          this.$message({
            type: 'warn',
            message: 'fail'
          })
        })
    },
    wizardComplete: function () {
      let that = this
      this.$refs.compliance.saveComplianceQuestionnaire((params) => {
        // console.log('-----------', params)
        that
          .$confirm(
            'KYC information cannot be changed after submission. Confirm submission?',
            'warning',
            {
              confirmButtonText: 'Submit',
              cancelButtonText: 'Just Save', // Cancel
              type: 'warning',
            }
          )
          .then(() => {
            that.submitKycInformation(params, () => {
              // 提交刷新页面到 submitted 页面
              // console.log(' // 提交刷新页面到 submitted 页面')
              location.reload()
            })
          }, () => {
            that.updateKycInformation({ 0: params,
              1: () => {
                // 提交刷新页面 saved
                // console.log('// 提交刷新页面 saved')
                location.reload()
              } })
          })
      })
    },
    changeCurrentStep: function (index) {
      let that = this
      switch (index) {
        case 0:
          this.currentComponent = 'basicInformation'
          break
        case 1:
          that.getMerchantKYCInfo(3, res => {
            if (!res.upload_attachment_info) {
              that.$message({
                type: 'warn',
                message: 'Please fill in step by step'
              })
              that.$refs.simpleHorizontalIndicator.currentStep = 0
              that.currentComponent = 'basicInformation'
            } else {
              that.currentComponent = 'businessInformation'
            }
          })
          break
        case 2:
          that.getMerchantKYCInfo(9, res => {
            if (!res.upload_attachment_info) {
              that.$message({
                type: 'warn',
                message: 'Please fill in step by step'
              })
              that.$refs.simpleHorizontalIndicator.currentStep = 0
              that.currentComponent = 'basicInformation'
            } else if (!res.ultimate_beneficiary_list || res.ultimate_beneficiary_list.length === 0) {
              that.$message({
                type: 'warn',
                message: 'Please fill in step by step'
              })
              that.$refs.simpleHorizontalIndicator.currentStep = 1
              that.currentComponent = 'businessInformation'
            } else {
              that.$refs.simpleHorizontalIndicator.currentStep = 2
              that.currentComponent = 'complianceQuestionnaire'
            }
          })

          break
        default:
          break
      }
    },
    isValidAll () {
      if (this.currentComponent === 'basicInformation') {
        this.$refs.basicInfo.saveBasicInfo((result) => {
          if (result) {
            this.currentComponent = 'licenseInformation'
          }
        })
      } else if (this.currentComponent === 'licenseInformation') {
        this.$refs.licenseInfo.saveLicenseInfo((result) => {
          if (result) {
            this.currentComponent = 'uploadAttachment'
          }
        })
      } else if (this.currentComponent === 'uploadAttachment') {
        this.$refs.uploadAttachment.saveUploadAttachment((result) => {
          if (result) {
            this.$refs.simpleHorizontalIndicator.currentStep = 1
            this.currentComponent = 'businessInformation'
          } else {
            this.$refs.simpleHorizontalIndicator.currentStep = 0
          }
        })
        // return true
      } else if (this.currentComponent === 'businessInformation') {
        this.$refs.businessInformation.saveBusinessInformation((result) => {
          if (result) {
            this.currentComponent = 'bankInformation'
          }
        })
      } else if (this.currentComponent === 'bankInformation') {
        this.$refs.bankInfo.saveBankInfo((result) => {
          if (result) {
            this.currentComponent = 'seniorManagement'
          }
        })
      } else if (this.currentComponent === 'seniorManagement') {
        this.$refs.seniorManage.saveSenior((result) => {
          if (result) {
            this.currentComponent = 'ultimateBeneficiary'
          }
        })
      } else if (this.currentComponent === 'ultimateBeneficiary') {
        this.$refs.ultimateBenefit.saveUltimate((result) => {
          if (result) {
            this.$refs.simpleHorizontalIndicator.currentStep = 2
            this.currentComponent = 'complianceQuestionnaire'
          } else {
            this.$refs.simpleHorizontalIndicator.currentStep = 1
          }
        })
        // return true
      } else if (this.currentComponent === 'complianceQuestionnaire') {

      }
    },
    next () {
      // if (this.currentComponent === "basicInformation") {
      // } else if (this.currentComponent === "licenseInformation") {
      // } else if (this.currentComponent === "uploadAttachment") {
      // } else if (this.currentComponent === "businessInformation") {
      // } else if (this.currentComponent === "bankInformation") {
      // } else if (this.currentComponent === "seniorManagement") {
      // } else if (this.currentComponent === "ultimateBeneficiary") {
      // } else if (this.currentComponent === "complianceQuestionnaire") {
      // }
    },
    back () {
      let that = this
      if (that.currentComponent === 'licenseInformation') {
        // that.$refs.licenseInfo.saveLicenseInfo((result) => {
        //   if (result) {
        that.currentComponent = 'basicInformation'
        //   }
        // })
      } else if (that.currentComponent === 'uploadAttachment') {
        // that.$refs.uploadAttachment.saveUploadAttachment((result) => {
        //   if (result) {
        that.currentComponent = 'licenseInformation'
        //   }
        // })
      } else if (that.currentComponent === 'businessInformation') {
        // that.$refs.businessInformation.saveBusinessInformation((result) => {
        //   if (result) {
        that.currentComponent = 'uploadAttachment'
        //   }
        // })
      } else if (that.currentComponent === 'bankInformation') {
        // that.$refs.bankInfo.saveBankInfo((result) => {
        //   if (result) {
        that.currentComponent = 'businessInformation'
        //   }
        // })
      } else if (that.currentComponent === 'seniorManagement') {
        // that.$refs.seniorManage.saveSenior((result) => {
        //   if (result) {
        that.currentComponent = 'bankInformation'
        //   }
        // })
      } else if (that.currentComponent === 'ultimateBeneficiary') {
        // that.$refs.ultimateBenefit.saveUltimate((result) => {
        //   if (result) {
        that.currentComponent = 'seniorManagement'
        //   }
        // })
      } else if (that.currentComponent === 'complianceQuestionnaire') {
        // that.$refs.compliance.saveComplianceQuestionnaire(params => {
        //   that.updateKycInformation({ 0: params,
        //     1: () => {
        that.currentComponent = 'ultimateBeneficiary'
        //     } })
        // }, () => {
        //   that.$refs.simpleHorizontalIndicator.currentStep = 2
        // })
      }
      // else if (this.currentComponent === 'complianceQuestionnaire') {
      //   // 成功
      //   this.$confirm(
      //     'KYC information cannot be changed after submission. Confirm submission?',
      //     'warning',
      //     {
      //       confirmButtonText: 'Submit',
      //       cancelButtonText: 'Just Save', // Cancel
      //       type: 'warning',
      //     }
      //   ).then(() => {
      //     alert(132)
      //   })
      // }
    },
    async savedAll () {
      let merchantData = await this.getAllData()
      this.updateKycInformation({ 0: merchantData,
        1: () => {
          // console.log('保存成功')
        } })
    },
    async submitAllInfo () {
      let merchantData = await this.getAllData()
      this.submitKycInformation(merchantData, () => {
        // console.log('提交成功')
        location.reload()
      })
    },
    submitAll () {
      let that = this
      this.$confirm(
        'KYC information cannot be changed after submission. Confirm submission?',
        'warning',
        {
          confirmButtonText: 'Submit',
          cancelButtonText: 'Just Save', // Cancel
          type: 'warning',
        }
      ).then(() => {
        that.submitAllInfo()
      }, () => {
        that.savedAll()
      })
    },
    async getAllData () {
      let allData = {
        bank_info: '',
        base_info: '',
        business_info_list: {},
        compliance_questionnaire: '',
        license_info: '',
        senior_management_list: '',
        ultimate_beneficiary_list: '',
        upload_attachment_info: '',
        page: 9,
      }
      await this.$refs.basicInfo.getBasicInfo().then(res => {
        allData.base_info = res.base_info
      })
      await this.$refs.licenseInfo.getLicenseInfo().then(res => {
        allData.license_info = res.license_info
      })
      await this.$refs.uploadAttachment.getUploadAttachment().then(res => {
        allData.upload_attachment_info = res.upload_attachment_info
      })
      // this.$refs.businessInformation.getBusinessInformation().then(res => {
      //   console.log('getBasicInfo-1', res) // 空对象
      // })
      await this.$refs.bankInfo.getBankInfo().then(res => {
        allData.bank_info = res.bank_info
      })
      await this.$refs.seniorManage.getSenior().then(res => {
        allData.senior_management_list = res.senior_management_list
      })
      await this.$refs.ultimateBenefit.getUltimate().then(res => {
        allData.ultimate_beneficiary_list = res.ultimate_beneficiary_list
      })
      await this.$refs.compliance.getComplianceQuestionnaire().then(res => {
        allData.compliance_questionnaire = res.compliance_questionnaire
      })
      return allData
    },
    changeUltimateBeneficiary (item) {
      this.$refs.ultimateBenefit.ultimateBeneficiaryList.push(item)
    },
    changeSeniorManagement (item) {
      this.$refs.seniorManage.seniorManagementList.push(item)
    },
    changeRegionHK (flag) {
      this.$refs.uploadAttachment.isHK = flag
    }
  },
  provide () {
    return {
      merchantNo: localStorage.getItem('merchantNo') || ''
    }
  },
}
</script>
<style lang="scss">
.info-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  .info-group-space {
    width: 4rem;
  }
}
.kyc-saved-m {
  height: 20px;
  background-color: #eeeeee;
  margin: 10px 0;
}
.kyc-information-status {
  background-color: #fff;
  margin: -1.2rem 0 1rem 0;
  padding: 10px 0 5px 1.5625rem;
}
.senior-top {
  display: flex;
  flex-direction: row;
  .senior-title {
    float: left;
  }
  .senior-buttons {
    display: flex;
    flex-direction: row;
    .btn.btn-sm,
    .btn-group-sm > .btn {
      margin-right: 20px;
    }
  }
}
fieldset[disabled="disabled"] {
  .control-label {
    font-size: 0.6rem;
    color: #4ae387;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
  }
  .vuestic-simple-select__unselect {
    display: none;
  }
}
input[disabled="disabled"] ~ label.control-label {
  font-size: 0.6rem;
  color: #4ae387;
  font-weight: 600;
  text-transform: uppercase;
  top: -0.6rem;
  left: 0;
}
.el-pagination {
  text-align: center;
}

</style>
